<template>
  <div class="p-4 md:p-6 flex flex-col">
    <div class="flex justify-between">
      <span class="font-light text-2xl py-3">Categories</span>
      <button
        class="border rounded p-2 bg-grey-light text-grey-dark hover:bg-grey-dark hover:text-grey-light"
        @click.prevent="$refs.add_category_tags.open()"
      >
        <i class="fa fa-plus"></i> Category
      </button>
    </div>
    <div class="flex flex-wrap">
      <draggable v-model="categorized_tags" class="flex-1 flex flex-wrap" @end="saveSorting">
        <categories
          :category="category"
          v-for="category in categorized_tags"
          :key="category.id"
          @edit-category-tags="edit"
        ></categories>
      </draggable>

      <p class="p-2 bg-orange-lightest w-full m-2 text-xs italic border-l-4 border-orange-light">
        <span class="text-red font-semibold">*</span>Needs
        <router-link
          :to="{name: 'role-restrictions-tag', params: {vault_id: $route.params.vault_id}}"
          class="text-black"
        >Role Assignment</router-link>
      </p>
    </div>

    <sweet-modal
      ref="add_category_tags"
      overlay-theme="dark"
      enable-mobile-fullscreen
      @close="getCategories()"
    >
      <form data-vv-scope="add-category" @submit.prevent="addCategory" v-show="show.add_category">
        <div class="w-full text-left my-4">
          <label class="font-medium">Category Name</label>
          <input
            type="text"
            class="w-full border py-2 px-3 mt-2 rounded"
            v-model="add_category_tag.name"
            v-validate="'required'"
            name="category_name"
            tabindex="1"
            :class="{'border-red':errors.has('add-category.category_name')}"
          >
          <div
            v-show="errors.has('add-category.category_name')"
            class="text-red text-sm mt-2"
          >{{ errors.first('add-category.category_name') }}</div>
        </div>

        <div class="w-full flex justify-end mb-2">
          <button
            class="border bg-brand px-4 py-3 text-white rounded font-medium hover:bg-brand-darker hover:border-brand-darker"
            type="submit"
            :class="{'cursor-not-allowed text-white bg-grey-dark border-grey opacity-75': loading.add_category}"
          >
            <span v-if="loading.add_category">
              <i class="fa fa-spin fa-circle-notch"></i>
            </span>
            <span v-else>
              <i class="fa fa-plus"></i> Add
            </span>
          </button>
        </div>
      </form>

      <form data-vv-scope="add-tag" @submit.prevent="addTags" v-show="show.add_tags">
        <div class="w-full text-left my-4">
          <label class="font-medium">Category:</label>
          <span>{{add_category_tag.name}}</span>
          <!-- <input type="text" 
                        class="w-full border py-2 px-3 mt-2 rounded" 
                        v-model="add_category.name"
                        v-validate="'required'"
                        name="name"
                        tabindex="1"
                        :class="{'border-red':errors.has('add-category.name')}">
                    <div v-show="errors.has('add-category.name')" class="text-red text-sm mt-2">
                        {{ errors.first('add-category.name') }}
          </div>-->
        </div>

        <div class="w-full text-left my-4">
          <label class="font-medium">Tags:</label>

          <div v-for="tag, idx in add_category_tag.tags" :key="idx" class="flex">
            <div class="flex-1">
              <input
                type="text"
                class="w-full border py-2 px-3 mt-2 rounded"
                v-model="tag.name"
                v-validate="'required'"
                :name="'tag_name' + idx"
                tabindex="1"
                placeholder="Name"
                :class="{'border-red':errors.has('add-tag.tag_name'+idx)}"
              >
            </div>
            <div class="flex-1">
              <input
                type="text"
                class="w-full border py-2 px-3 m-2 rounded"
                v-model="tag.abbv"
                v-validate="'required'"
                :name="'tag_abbv' + idx"
                tabindex="1"
                placeholder="Abbreviation"
                :class="{'border-red':errors.has('add-tag.tag_abbv'+idx)}"
              >
            </div>
          </div>
        </div>

        <div class="w-full flex justify-between mb-2">
          <button
            class="border bg-grey px-4 py-3 text-white rounded font-medium hover:bg-grey-darker hover:border-grey-darker"
            type="button"
            @click.prevent="addTagEntry(add_category_tag)"
          >
            <i class="fa fa-plus"></i> Tag
          </button>
          <button
            class="border bg-brand px-4 py-3 text-white rounded font-medium hover:bg-brand-darker hover:border-brand-darker"
            type="submit"
          >
            <i class="fa fa-save"></i> Save Tags
          </button>
        </div>
      </form>
    </sweet-modal>

    <sweet-modal
      ref="edit_category_tags"
      overlay-theme="dark"
      enable-mobile-fullscreen
      @close="getCategories()"
    >
      <form data-vv-scope="edit-category-tags" @submit.prevent="updateCategoryTags">
        <div class="w-full text-left my-4">
          <label class="font-medium">Category Name</label>
          <input
            type="text"
            class="w-full border py-2 px-3 mt-2 rounded"
            v-model="edit_category_tags.name"
            v-validate="'required'"
            name="category_name"
            tabindex="1"
            :class="{'border-red':errors.has('edit-category-tags.category_name')}"
          >
          <div
            v-show="errors.has('edit-category-tags.category_name')"
            class="text-red text-sm mt-2"
          >{{ errors.first('edit-category-tags.category_name') }}</div>
        </div>

        <div class="w-full text-left my-4">
          <label class="font-medium">Tags:</label>

          <div v-for="tag, idx in edit_category_tags.tags" :key="idx" class="flex">
            <div class="flex-1">
              <input
                type="text"
                class="w-full border py-2 px-3 mt-2 rounded"
                v-model="tag.name"
                v-validate="'required'"
                :name="'tag_name' + idx"
                tabindex="1"
                placeholder="Name"
                :class="{'border-red':errors.has('edit-category-tags.tag_name'+idx)}"
              >
            </div>
            <div class="flex-1">
              <input
                type="text"
                class="w-full border py-2 px-3 m-2 rounded"
                v-model="tag.abbv"
                v-validate="'required'"
                :name="'tag_abbv' + idx"
                tabindex="1"
                placeholder="Abbreviation"
                :class="{'border-red':errors.has('edit-category-tags.tag_abbv'+idx)}"
              >
            </div>
            <div class="flex-none flex items-center ml-4">
              <button
                type="button"
                class="text-red font-semibold"
                @click.prevent="$refs.confirm_delete_tag.open(); pending_deletion = tag"
              >
                <i class="far fa-trash-alt"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="text-right mb-2 mr-6">
          <button
            class="border bg-grey p-2 text-white rounded font-medium hover:bg-grey-darker hover:border-grey-darker"
            type="button"
            @click.prevent="addTagEntry(edit_category_tags)"
          >
            <i class="fa fa-plus"></i> Tag
          </button>
        </div>
      </form>

      <div class="pt-8 mt-8 w-full flex justify-between border-t">
        <button
          type="button"
          class="bg-red rounded p-3 text-white"
          @click.prevent="$refs.confirm_delete_category.open(); pending_deletion = edit_category_tags"
        >
          <i class="fa fa-trash-alt"></i> Category
        </button>

        <button
            class="border bg-brand px-4 py-3 text-white rounded font-medium hover:bg-brand-darker hover:border-brand-darker"
            @click.prevent="updateCategoryTags()"
            :class="{'cursor-not-allowed text-white bg-grey-dark border-grey opacity-75': loading.editing}"
          >
            <span v-if="loading.editing">
              <i class="fa fa-spin fa-circle-notch"></i>
            </span>
            <span v-else>
              <i class="fa fa-save"></i> Update
            </span>
        </button>
      </div>
    </sweet-modal>

    <sweet-modal icon="warning" overlay-theme="dark" ref="confirm_delete_tag">
      <div class="flex flex-col">
        <span>Are you sure you want to delete this Tag?</span>

        <div class="mt-6">
          <button
            class="border bg-brand p-4 w-32 text-white rounded font-medium"
            @click.prevent="deleteTag()"
            type="button"
          >Yes</button>
          <button
            class="border bg-grey-lighter p-4 w-32 text-black border-grey rounded font-medium"
            @click.prevent="$refs.confirm_delete_tag.close()"
            type="button"
          >No</button>
        </div>
      </div>
    </sweet-modal>

    <sweet-modal icon="warning" overlay-theme="dark" ref="confirm_delete_category">
      <div class="flex flex-col">
        <p>
          Are you sure you want to delete this Category?
          <br>This will also delete the Tags under this Category
        </p>

        <div class="mt-6">
          <button
            class="border bg-brand p-4 w-32 text-white rounded font-medium"
            @click.prevent="deleteCategory()"
            type="button"
          >Yes</button>
          <button
            class="border bg-grey-lighter p-4 w-32 text-black border-grey rounded font-medium"
            @click.prevent="$refs.confirm_delete_category.close()"
            type="button"
          >No</button>
        </div>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Categories from "../../components/ManageTag/Categories";
import draggable from "vuedraggable";

export default {
  components: {
    Categories,
    draggable
  },
  data() {
    return {
      categorized_tags: [],

      add_category_tag: {
        name: "",
        id: "",
        tags: []
      },

      edit_category_tags: {},

      pending_deletion: {},

      show: {
        add_category: true,
        add_tags: false
      },

      loading: {
        add_category: false,
        add_tag: false,
        editing: false
      }
    };
  },

  mounted() {
    this.getCategories();

    this.$ebus.$on("tags-updated", () => {
      this.$noty.success("Tags have been updated");
    });
  },

  methods: {
    getCategories() {
      axios
        .get(`api/vaults/${this.$route.params.vault_id}/categories`)
        .then(({ data }) => {
          this.categorized_tags = data;
        });
    },

    addCategory() {
      this.loading.add_category = true;
      this.$validator.validateAll("add-category").then(result => {
        if (result) {
          axios
            .post(`api/vaults/${this.$route.params.vault_id}/categories`, {
              name: this.add_category_tag.name,
              order: this.categorized_tags.length
            })
            .then(({ data }) => {
              if (!_.isEmpty(data)) {
                this.$noty.success(
                  `Category ${this.add_category_tag.name} has been added`
                );
                this.add_category_tag.id = data.id;
                this.loading.add_category = false;
                this.show.add_category = false;
                this.show.add_tags = true;
              }
            });
        } else {
          this.loading.add_category = false;
        }
      });
    },

    addTags() {
      this.loading.add_tag = true;
      this.$validator.validateAll("add-category").then(result => {
        if (result) {
          let order = 1;
          _.each(this.add_category_tag.tags, tag => {
            axios
              .post(
                `api/vaults/${this.$route.params.vault_id}/categories/${
                  this.add_category_tag.id
                }/tags`,
                {
                  name: tag.name,
                  abbv: tag.abbv,
                  order: order
                }
              )
              .then(({ data }) => {
                this.$noty.success(
                  `Tag ${tag.name} has been added to Category ${
                    this.add_category_tag.name
                  }`
                );
                order++;

                if (_.last(this.add_category_tag.tags).name == tag.name) {
                  this.loading.add_category = false;
                  this.show.add_category = true;
                  this.show.add_tags = false;
                  this.add_category_tag = {
                    name: "",
                    id: "",
                    tags: []
                  };
                  this.$validator.reset();
                  this.$refs.add_category_tags.close();
                  this.$ebus.$emit("get-categorized-tags");
                }
              });
          });
        } else {
          this.loading.add_category = false;
        }
      });
    },

    addTagEntry(data) {
      let new_tag = {
        name: "",
        abbv: ""
      };
      data.tags.push(new_tag);
    },

    edit(payload) {
      this.edit_category_tags = _.cloneDeep(payload);
      this.$refs.edit_category_tags.open();
    },

    updateCategoryTags() {
      this.loading.editing = true;
      this.$validator.validateAll("edit-category-tags").then(result => {
        if (result) {
          axios
            .patch(
              `api/vaults/${this.$route.params.vault_id}/categories/${
                this.edit_category_tags.id
              }`,
              {
                name: this.edit_category_tags.name,
                order: this.edit_category_tags.order
              }
            )
            .then(({ data }) => {
              if (!_.isEmpty(data)) {
                let order = 1;
                let selected_category = _.find(this.categorized_tags, [
                  "id",
                  this.edit_category_tags.id
                ]);

                if (!_.isEmpty(this.edit_category_tags.tags)) {
                  _.each(this.edit_category_tags.tags, (tag, index) => {
                    if (!_.isNil(tag.id)) {
                      let selected_tags = "";
                      if (!_.isNil(selected_category)) {
                        selected_tags = selected_category.tags;
                      }

                      let matched_tag = _.find(selected_tags, ["id", tag.id]);

                      if (
                        matched_tag.name != tag.name ||
                        matched_tag.abbv != tag.abbv
                      ) {
                        axios
                          .patch(
                            `api/vaults/${
                              this.$route.params.vault_id
                            }/categories/${data.id}/tags/${tag.id}`,
                            {
                              name: tag.name,
                              abbv: tag.abbv,
                              order: tag.order
                            }
                          )
                          .then(({ data }) => {
                            if (!_.isEmpty(data)) {
                              this.$noty.success(`Tag names have been updated`);
                              this.$ebus.$emit("get-categorized-tags");
                            }
                          });
                      }
                    } else {
                      axios
                        .post(
                          `api/vaults/${
                            this.$route.params.vault_id
                          }/categories/${this.edit_category_tags.id}/tags`,
                          {
                            name: tag.name,
                            abbv: tag.abbv,
                            order: index + 1
                          }
                        )
                        .then(({ data }) => {
                          if (!_.isEmpty(data)) {
                            this.edit_category_tags.tags[index] = data;
                            this.$noty.success(
                              `Tag ${tag.name} has been added to Category ${
                                this.edit_category_tags.name
                              }`
                            );
                            this.getCategories();
                          }
                        });
                    }

                    if (
                      index == _.findLastIndex(this.edit_category_tags.tags)
                    ) {
                      this.loading.editing = false;
                      //   this.edit_category_tags = {
                      //     name: "",
                      //     id: "",
                      //     tags: []
                      //   };
                      this.$validator.reset();
                      this.$ebus.$emit("get-categorized-tags");
                    }
                  });
                } else {
                  this.loading.editing = false;
                  //   this.edit_category_tags = {
                  //     name: "",
                  //     id: "",
                  //     tags: []
                  //   };
                  this.$validator.reset();
                  this.$noty.success(
                    `Category ${this.edit_category_tags.name} has been updated`
                  );
                  this.$ebus.$emit("get-categorized-tags");
                }
              }
            }).finally(() => {
              this.$refs.edit_category_tags.close();
            });
        } else {
          this.loading.editing = false;
        }
      });
    },

    deleteTag() {
      if (_.isEmpty(this.pending_deletion.abbv) && _.isEmpty(this.pending_deletion.name)) {
        this.edit_category_tags.tags.splice(
          _.findLastIndex(this.edit_category_tags.tags),
          1
        );
        this.$refs.confirm_delete_tag.close();
      } else {
        let tag = this.pending_deletion;
        axios
          .delete(
            `api/vaults/${this.$route.params.vault_id}/categories/${
              this.edit_category_tags.id
            }/tags/${tag.id}`
          )
          .then(({ data }) => {
            if (data.success) {
              this.getCategories();
              this.$noty.success(data.message);
              this.edit_category_tags.tags.splice(
                _.findIndex(this.edit_category_tags.tags, ["id", tag.id]),
                1
              );
            }
            this.$refs.confirm_delete_tag.close();
            this.$ebus.$emit("get-categorized-tags");
          })
          .catch(error => {
            this.$refs.confirm_delete_tag.close();
          });
      }

    },

    deleteCategory() {
      this.$refs.confirm_delete_category.close();
      let category = this.pending_deletion;
      axios
        .delete(
          `api/vaults/${this.$route.params.vault_id}/categories/${category.id}`
        )
        .then(({ data }) => {
          if (data.success) {
            this.$noty.success(data.message);
            this.$refs.edit_category_tags.close();
            this.$ebus.$emit("get-categorized-tags");
          }
        });
    },

    isAssignedtoRole(cat_id, tag_id) {
      let categories = _.find(this.cat_tags, ["id", cat_id]);
      if (!_.isEmpty(categories)) {
        let tags = _.find(categories.tags, ["id", tag_id]);
        if (_.isEmpty(tags)) {
          return false;
        }
      }

      return true;
    },

    saveSorting() {
      _.each(this.categorized_tags, (category, idx) => {
        let order = idx + 1;
        axios
          .patch(
            `api/vaults/${this.$route.params.vault_id}/categories/${
              category.id
            }`,
            {
              name: category.name,
              abbv: category.abbv,
              order: order
            }
          )
          .then(({ data }) => {
            if (idx == _.findLastIndex(this.categorized_tags)) {
              this.$ebus.$emit("get-categorized-tags");
              this.$noty.success("Tag sorting have been updated");
            }
          });
      });
    }
  },

  computed: {
    ...mapGetters({
      cat_tags: "getCategorizedTags"
    })
  }
};
</script>

<style>
</style>
